export default __webpack_public_path__ + "static/media/hrrr.43422d9c.jpg";